"use strict";

define('app/models/task.manager',['rs/models/notification.manager', 'rs/models/task', 'rs/services/workflow.service', 'rs/paginate', 'rs/helper', 'moment'], function (NotificationManager, Task, WorkflowService, Paginate, helper, moment) {
  var TaskManager = NotificationManager.extend({
    properties: [],
    options: {
      name: 'tasks',
      displayName: 'Tasks'
    },
    initialize: function initialize() {
      this.paginate = new Paginate({
        sort: 'taskBeginDate',
        sortDirection: 'desc',
        size: 100
      });
      this._super.apply(this, arguments);
    },
    _requestItems: function _requestItems() {
      return WorkflowService.requestTasks(this.paginate);
    },
    _getIdFromItem: function _getIdFromItem(item) {
      return item.taskBeginDate;
    },
    _getTitleFromItem: function _getTitleFromItem(item) {
      return item.taskAction + ' - ' + item.studyTitle;
    },
    _getDateFromItem: function _getDateFromItem(item) {
      return moment(item.taskBeginDate).calendar();
    },
    _getBodyFromItem: function _getBodyFromItem(item) {},
    _getUnreadFromItem: function _getUnreadFromItem() {
      return false;
    },
    _getUrgencyFromItem: function _getUrgencyFromItem(item) {
      return item.isPastDue();
    },
    _getSelectable: function _getSelectable() {
      return true;
    }
  });
  return TaskManager;
});

